import type { FaireProductEntity } from "../../entity_types/product";

export const p_89gtz68tdu: FaireProductEntity = {
  token: "p_89gtz68tdu",
  type: "product",
  name: "Factory Convent Schoolhouse Home",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/b500d618b693147a59cc91e1ba1dc98a31a324b48cb01eeeb778ededabea8d5b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/42b3c9e8a4fe936cc34d6ab8052e77b2b7a39a0d5851e6a7575a4b85e8f17870.jpeg",
    "https://cdn.faire.com/fastly/480b5144ba05e2e07ac7e0774206075ab0521df5d051ece857360fe63d3f717c.jpeg",
    "https://cdn.faire.com/fastly/32a77baa62d7a2c0e8725d78aadcfc7e5e419f72e586edf19f8550811cc5d97f.jpeg",
    "https://cdn.faire.com/fastly/0ecc15248066ea41c09f8f14822e8fbfebe90e00cc810255642c5287a3a28fab.jpeg",
    "https://cdn.faire.com/fastly/da1684ac704cebe417057e1cba91729a4dfa8569a6094cc77d3691558e99b75f.jpeg",
    "https://cdn.faire.com/fastly/62c009e0daebc7a86bb91c29929b157b31355d0acd68b3cddf991639480948f7.jpeg",
    "https://cdn.faire.com/fastly/4e7cc9523f0cbf1bcd0ae3564db0242b2b2bfc5df779a5f5e2825bff20bc0c55.jpeg",
    "https://cdn.faire.com/fastly/28f8e6ad3c4ae42006045ed12f96f37c4072d7f79c65d37772be036b5561ad25.jpeg"
  ],
  priceDollars: 20,
  description: "A one-of-a-kind design book, showcasing transformations of unusual and non-traditional buildings into lived-in, layered homes. An air control tower in Scotland. A historic carpenter’s shop in Madrid. A laundromat in Texas. A medieval convent in Tuscany. None of these may seem the most obvious candidates for a beautiful, soulful family home—but that is just what each one has become in the hands of their curious and creative new stewards. In this book interior stylist and hotelier Lynda Gardener and photographer Lean Timms take us on a world tour of some the most astonishing home renovations you’ve ever seen. In listening to a building, whether it’s a piano factory or a fire station, and responding with restraint and imagination, these homeowners show us that we have the power to create homes that go beyond the expected to become something extraordinary.",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:55.545Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
